// Prompt builder for the INQA wizard. Mirrors the legacy `web/public/app.js`
// submit handler so the agent receives the exact same instructions.

import { GESTALTUNGSFELDER_TEXT, type InqaForm } from "./state";

export function buildInqaPrompt(form: InqaForm, slug: string): string {
  const felderList = form.gestaltungsfelder
    .map((n) => `${n} – ${GESTALTUNGSFELDER_TEXT[n] ?? ""}`)
    .join(", ");
  const runDirHint = `output/legacy_${slug}`;
  const websiteHint = form.websiteUrl.trim()
    ? `\nWebsite: ${form.websiteUrl.trim()} – bitte scrape nach ${runDirHint}/data/website.md und nutze die Inhalte als zusätzliche Informationsquelle.`
    : "";
  return `Erstelle eine INQA Projektreferenz für folgendes Projekt.

Run-Verzeichnis: ${runDirHint}
Die Formulardaten liegen in: ${runDirHint}/data/referenz_input.json

Projekttitel: ${form.projekttitel}
Branche: ${form.branche}
Mitarbeitende: ca. ${form.mitarbeitende}
Personentage: ${form.personentage} PT à ${form.stundenProTag || "8"}h
Zeitraum: ${form.zeitraumStart} – ${form.zeitraumEnd}
Gestaltungsfelder: ${felderList}${websiteHint}

Führe bitte die Pipeline gemäß System-Prompt durch und schreibe das Ergebnis nach: ${runDirHint}/referenz.md`;
}
